export var toResponsiveCssValue = value => {
  var result = {};

  for (var key in value) {
    var bp = key;
    result[bp] = toValidCssValue(value[bp]);
  }

  return result;
};
export var toValidCssValue = value => {
  if (typeof value === "number") return "".concat(value, "px");
  return value;
};